import * as vehiclesServices from './vehiclesServices';

export { vehiclesServices };
